import { z } from 'zod'

/**
 * ================================================================================================================
 *                                    Sub-Schema Definitions
 * ================================================================================================================
 */

/**
 * ----------------------------------------------------------------------------------------------------------------
 *                                    Org and Site Search Params
 * ----------------------------------------------------------------------------------------------------------------
 */

export const SEARCH_PARAM_ORG_ID = 'orgId'
export const SEARCH_PARAM_SITE_ID = 'siteId'

/**
 * A schema definition for the org and site search params.
 */
const orgAndSiteSearchParamsSchema = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
})

/**
 * ================================================================================================================
 *                                    Main Schema Definition
 * ================================================================================================================
 */

/**
 * A schema definition for the global search params, which is used to validate the search params of all routes.
 *
 * > NOTE: If you wish to add additional search params, please define a (non-exported) schema above and add it to this schema (you can follow
 * > the pattern used by `orgAndSiteSearchParamsSchema`).
 *
 * > NOTE: If you wish for your extra search params to be persisted by default, you must include the param-keys to persist in
 * > the `retainSearchParams` middleware on `__root`.
 */
export const globalSearchParamsSchema = z.object({
  ...orgAndSiteSearchParamsSchema.shape,
})

export type GlobalSearchParams = z.infer<typeof globalSearchParamsSchema>
